module.exports = __webpack_public_path__ + "img/info-circle.a1c3f214.svg";